<template>
  <div :class="wrapClasses" :style="styles" @click="onClickStep($event)">
    <div :class="[prefixCls + '-tail']"><i></i></div>
    <div :class="[prefixCls + '-head']">
      <div :class="[prefixCls + '-head-inner']">
        <span v-if="!icon && currentStatus !== 'finish' && currentStatus !== 'error'">{{ stepNumber }}</span>
        <span v-else :class="iconClasses"></span>
      </div>
    </div>
    <div :class="selectStepClasses">
      <div :class="[prefixCls + '-title']" :style="{color: selectStep === step ? 'blue' : 'inherit'}">{{ title }}</div>
      <slot>
        <div v-if="content" :class="[prefixCls + '-content']" :style="{color: selectStep === step ? 'blue' : 'inherit'}">{{ content }}</div>
      </slot>
    </div>
  </div>
</template>
<script>
import Emitter from './../mixins/emitter'
import { oneOf } from './../lib/assist'

const prefixCls = 'ivu-steps'
const iconPrefixCls = 'ivu-icon'

export default {
  name: 'dxy-step',
  mixins: [ Emitter ],
  props: {
    status: {
      validator (value) {
        return oneOf(value, ['wait', 'process', 'finish', 'error'])
      }
    },
    title: {
      type: String,
      default: ''
    },
    currentStep: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 0
    },
    selectStep: {
      type: Number,
      default: -1
    },
    bindData: {
      type: Object,
      default () {
        return {}
      }
    },
    content: {
      type: String
    },
    icon: {
      type: String
    }
  },
  data () {
    return {
      prefixCls: prefixCls,
      stepNumber: '',
      nextError: false,
      total: 1,
      currentStatus: ''
    }
  },
  computed: {
    selectStepClasses () {
      return [
        `${prefixCls}-main`,
        { 'selected-step-item': this.selectStep === this.step }
      ]
    },
    wrapClasses () {
      return [
        `${prefixCls}-item`,
        `${prefixCls}-status-${this.currentStatus}`,
        {
          [`${prefixCls}-custom`]: !!this.icon,
          [`${prefixCls}-next-error`]: this.nextError
        }
      ]
    },
    iconClasses () {
      let icon = ''

      if (this.icon) {
        icon = this.icon
      } else {
        if (this.currentStatus === 'finish') {
          icon = 'ios-checkmark'
        } else if (this.currentStatus === 'error') {
          icon = 'ios-close'
        }
      }

      return [
        `${prefixCls}-icon`,
        `${iconPrefixCls}`,
        {
          [`${iconPrefixCls}-${icon}`]: icon !== ''
        }
      ]
    },
    styles () {
      return {
        width: `${1 / this.total * 100}%`,
        cursor: this.step > this.currentStep ? 'not-allowed' : 'pointer'
      }
    }
  },
  watch: {
    status (val) {
      this.currentStatus = val
      if (this.currentStatus === 'error') {
        this.$parent.setNextError()
      }
    }
  },
  methods: {
    onClickStep (e) {
      e.preventDefault()
      this.$emit('on-step-click', this.bindData)
    }
  },
  created () {
    this.currentStatus = this.status
  },
  mounted () {
    this.dispatch('dxy-step', 'append')
  },
  beforeDestroy () {
    this.dispatch('dxy-step', 'remove')
  }
}
</script>
<style scoped>
.selected-step-item {
  color: #96ff9c;
}
</style>
